module.exports = __webpack_public_path__ + "close.svg?743cbd278e91e78045bcbd94b4bca8fa";